/**
 * Hero section. lg:two-column grid — headline + value prop + stats row on
 * the left, RFQ form card on the right. The left column's content is
 * top-aligned with the form, and the stats row is pushed to the bottom
 * (mt-auto) so its bottom edge aligns with the form's bottom edge.
 * Stacks below lg:.
 */
import { ContactForm } from "../ContactForm";
import { StatsRow } from "./StatsRow";

export function Hero() {
  return (
    <section
      id="home"
      className="section-anchor mx-auto max-w-7xl px-4 pb-32 pt-28 sm:px-6 sm:pb-40 sm:pt-32 lg:pt-36"
    >
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
        <div className="flex flex-col lg:col-span-7">
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
            Precision CNC Milling for
            <br />
            Prototypes &amp; Short Runs
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
            <span className="font-bold">AnyAngle</span> is a small, tech-forward CNC machine shop in Colorado.
            Quick-turn precision parts in aluminum, stainless, and steel
            for defense, aerospace, and product teams that need the pieces
            now, not next quarter.
          </p>
          <div className="mt-10 flex lg:mt-6 lg:flex-1">
            <StatsRow />
          </div>
        </div>

        <div className="lg:col-span-5">
          <div
            id="rfq"
            className="section-anchor rounded-xl border border-bg-border bg-bg-card/85 backdrop-blur-[8px] p-5 sm:p-6"
          >
            <div className="mb-4 flex items-center justify-between">
              <h2 className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-500">
                Request a quote
              </h2>
              <span className="text-xs text-slate-400">Replies within 1 business day</span>
            </div>
            <ContactForm variant="dark" />
          </div>
        </div>
      </div>
    </section>
  );
}
